import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateScannerFormAction } from '../_state/scannerForm.state';
import { ScannerDetailRecord } from '../types/sidecar';

type Props = {
  scanner: ScannerDetailRecord | null | undefined;
};

export const usePopulateScannerForm = ({ scanner }: Props) => {
  const populateForm = useSetAtom($populateScannerFormAction);

  React.useEffect(() => {
    populateForm(scanner);
  }, [scanner, populateForm]);
};
